/**
 * Draft PDP preview boot v5 — loads mdb-pdp-preview-v5.js on ?view=clean-box-draft.
 * New filename for Shopify sync.
 */
(function () {
  try {
    var p = new URLSearchParams(location.search || '');
    var v = (p.get('view') || '').toLowerCase();
    var f = (p.get('mdb_pdp') || '').toLowerCase();
    var wants =
      v === 'clean-box-draft' || v.indexOf('clean-box') !== -1 || f === 'draft' || f === '1';
    if (!wants || !/\/products\//.test(location.pathname)) return;
    if (window.__mdbPdpDraftBootV5) return;
    window.__mdbPdpDraftBootV5 = true;
    var sample = document.querySelector(
      'script[src*="/cdn/shop/t/"][src*="/assets/"], link[href*="/cdn/shop/t/"][href*="/assets/"]'
    );
    var href = '/cdn/shop/t/28/assets/mdb-pdp-preview-v5.js';
    if (sample) {
      href = (sample.src || sample.href).replace(/\/assets\/[^/?#]+.*/, '/assets/mdb-pdp-preview-v5.js');
    }
    var s = document.createElement('script');
    s.src = href + (href.indexOf('?') > -1 ? '&' : '?') + 'v=layout5';
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) {}
})();
